// extracted by mini-css-extract-plugin
export default {"status":"styles_status__USCIt","aliases":"styles_aliases__qY2uE","name":"styles_name__LeSH2","inn":"styles_inn__Bji36","tabToTop":"styles_tabToTop__ZPh77","api":"styles_api__rGMIj"};